var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 11.1666C13.5544 11.1666 11.1666 13.5544 11.1666 16.4999C11.1666 19.4454 13.5544 21.8333 16.4999 21.8333C19.4454 21.8333 21.8333 19.4454 21.8333 16.4999C21.8333 13.5544 19.4454 11.1666 16.4999 11.1666ZM13.8333 16.4999C13.8333 15.0272 15.0272 13.8333 16.4999 13.8333C17.9727 13.8333 19.1666 15.0272 19.1666 16.4999C19.1666 17.9727 17.9727 19.1666 16.4999 19.1666C15.0272 19.1666 13.8333 17.9727 13.8333 16.4999Z",
    fill: "#14B8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 1.83325C17.2363 1.83325 17.8333 2.43021 17.8333 3.16659V4.57316C23.3954 5.18802 27.8118 9.60443 28.4267 15.1666H29.8333C30.5696 15.1666 31.1666 15.7635 31.1666 16.4999C31.1666 17.2363 30.5696 17.8333 29.8333 17.8333H28.4267C27.8118 23.3954 23.3954 27.8118 17.8333 28.4267V29.8333C17.8333 30.5696 17.2363 31.1666 16.4999 31.1666C15.7635 31.1666 15.1666 30.5696 15.1666 29.8333V28.4267C9.60443 27.8118 5.18802 23.3954 4.57316 17.8333H3.16659C2.43021 17.8333 1.83325 17.2363 1.83325 16.4999C1.83325 15.7635 2.43021 15.1666 3.16659 15.1666H4.57316C5.18802 9.60443 9.60443 5.18802 15.1666 4.57316V3.16659C15.1666 2.43021 15.7635 1.83325 16.4999 1.83325ZM25.8333 16.4999C25.8333 11.3453 21.6546 7.16658 16.4999 7.16658C11.3453 7.16658 7.16658 11.3453 7.16658 16.4999C7.16658 21.6546 11.3453 25.8333 16.4999 25.8333C21.6546 25.8333 25.8333 21.6546 25.8333 16.4999Z",
    fill: "#14B8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2cc8d1f35ee9cff54a876ca27eb13d94.svg";
export { ForwardRef as ReactComponent };